export default (ngModule: ng.IModule) => {
  ngModule.directive('empresasFiltro', empresasFiltroDirective);
};

function empresasFiltroDirective(): ng.IDirective {
  return {
    restrict: 'E',
    template: require('./empresas-filtro.html'),
    scope: {
      limpar: '='
    },
    controller: FiltroController,
    controllerAs: 'vm',
    bindToController: true
  };
}

/** @ngInject */
function FiltroController($mdSidenav, $mdMedia, $state, $window, Cidades, Empresas) {
  let vm = this;

  vm.$mdMedia = $mdMedia;
  vm.close = () => $mdSidenav('left').close();
  vm.toggle = () => $mdSidenav('left').toggle();
  vm.voltar = () => $window.history.back();
  vm.mostrarBtnVoltar = () => {
    return $state.is('consulta.empresas.detalhe') || !$state.is('consulta.empresas.listagem', {index: 0});
  };
  vm.titulo = () => $state.is('consulta.empresas.detalhe') ? 'Detalhes do Empresa' : 'Empresas';

  vm.Empresas = Empresas;
  vm.buscarCidades = Cidades.buscarCidades;
  vm.limpar = limpar;
  vm.buscarEmpresas = buscarEmpresas;

  function limpar() {
    vm.searchLocal = '';
    Empresas.limparFiltro();
  }

  function buscarEmpresas() {
    Empresas.limparCache();
    $state.go('consulta.empresas.listagem', {index: 0}, {reload: true});
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/empresas/empresas-filtro.directive.ts
 **/